import React from 'react';
import Button from 'components/Button';
import {Trans, useTranslation} from 'react-i18next';
import {SearchObjectType, useSearchApi} from 'features/layout/DialogRoutes/dialogs/search/hooks';
import SearchMoveForm from 'components/forms/SearchMoveForm';
import Box from '@mui/material/Box';
import SearchResults from 'components/SearchResults';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import SearchResultsList from 'components/SearchResultsList';
import Grid from '@mui/material/Grid';
import Panel from 'components/Panel';
import {filterByObjectType} from 'common/utils';

type SearchOpenPGPKeysFormProps = {
   onClose?: () => void;
};

const SearchOpenPGPKeysForm = ({onClose}: SearchOpenPGPKeysFormProps) => {
   const {t} = useTranslation();
   const {results, search, exportResults} = useSearchApi(
      SearchObjectType.PGP,
      t('OpenPGP Key Export'),
      t('Selected keys successfully exported')
   );

   const publicKeys = React.useMemo(
      () => filterByObjectType(results, DiplomatObjectType.enum.PUBLIC_KEY),
      [results]
   );
   const keyPairs = React.useMemo(
      () => filterByObjectType(results, DiplomatObjectType.enum.KEY_PAIR),
      [results]
   );

   return (
      <>
         <SearchMoveForm
            searchFieldsLabel={t('Include all keys or find keys with:')}
            searchResult={
               results ? <Trans t={t}>{{itemsCount: results.length}} keys found.</Trans> : null
            }
            onSubmit={search}
         />
         <SearchResults
            label={t('Double-click to edit a key.')}
            data={results}
            resultListComponent={
               <>
                  <Grid item xs={6}>
                     <Panel name={t('Public Keys')}>
                        <SearchResultsList data={publicKeys} />
                     </Panel>
                  </Grid>
                  <Grid item xs={6}>
                     <Panel name={t('Key Pairs')}>
                        <SearchResultsList data={keyPairs} />
                     </Panel>
                  </Grid>
               </>
            }
            onExport={exportResults}
         />
         {onClose && (
            <Box textAlign={'center'}>
               <Button onClick={onClose}>{t('Close')}</Button>
            </Box>
         )}
      </>
   );
};

export default React.memo(SearchOpenPGPKeysForm);
